import {NgModule} from "@angular/core";
import {ButtonComponent} from "./button.component";
import {CommonModule} from "@angular/common";
import {CPTranslateModule} from "../../../translate";
import {ButtonComponentCustom} from "./button.component.custom";
import {ButtonStripComponent} from "./button.strip/button.strip.component";

@NgModule({
	declarations: [
		ButtonComponent,
		ButtonComponentCustom,
		ButtonStripComponent
	],
	exports: [
		ButtonComponent,
		ButtonComponentCustom,
		ButtonStripComponent
	],
	imports: [
		CommonModule,
		CPTranslateModule
	]
})
export class ButtonModule { }
